import { render } from "./ModalNovoPrograma.vue?vue&type=template&id=c678f71c"
import script from "./ModalNovoPrograma.vue?vue&type=script&lang=js"
export * from "./ModalNovoPrograma.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__